// extracted by mini-css-extract-plugin
module.exports = {"voucher":"styles_voucher__K5tib","cars":"styles_cars__1lG4B","brandLogo":"styles_brandLogo__3DhaN"};